<template>
  <div class="l_location">
    <div class="c_location">
      <!-- Map component-->
      <div class="l_map">
        <g-map></g-map>
      </div>
    </div>
  </div>

</template>

<script>
import GMap from '@/components/GMap.vue'

export default {
  name: 'Location',
  components: {
    GMap
  }
}
</script>

<style scoped>

.l_location {
  height: 100%;
}

.l_map {
   height: 100%;
   width: 100%;
}

.c_top_navigation {
  padding: 10px 0px 10px 10px;
  text-align: justify;
}

.c_location {
  height: 100%;
}

.c_setting {
  border: 1px solid gray;
  background-color: transparent;
  border-radius: 30px;
  width: 30px;
  height: 30px;
  margin-right: 10px;
  color: gray;
}

.c_setting img {
  width: 10px;
  height: 10px;
}

.c_selection {
  width: 100px;
  height: 30px;
  border: 1px solid gray;
  background-color: transparent;
  border-radius: 20px;
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 3px;
  text-align-last:center;
  color: gray;
}

.c_currently {
  width: 100px;
  height: 30px;
  border: 1px solid gray;
  background-color: transparent;
  border-radius: 20px;
  margin-left: 10px;
  color: gray;
}

.c_filter {
  color : #007EED;
  margin-left: 10px;
  font-size: 15px;
}

.l_bottom_navigation {
  width: 100px;
  height: 30px;
  text-align: justify;
  padding: 20px;
}

.c_list {
  color : #007EED;
  font-size: 15px;
}
</style>
